<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <p class="modal-title h4" jhiTranslate="modals.changeOrder.title"></p>
  </div>

  <form>
    <div class="modal-body text-left">
      <div class="row" *ngIf="model">
        <div class="col-12 pb-2">
          <span class="color-gray font-weight-bold" jhiTranslate="modals.changeOrder.subTitle"></span>
        </div>
        <div class="col-12">
          <jhi-bary-sortable-list [showPosition]="true" [labelField]="labelField" [items]="model"></jhi-bary-sortable-list>
        </div>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <div class="row">
        <div class="col-auto">
          <jhi-bary-button
            [outline]="true"
            color="primary"
            [label]="'modals.changeOrder.buttons.cancel' | translate"
            (clickEvent)="handleClick({ cancel: true })"
          ></jhi-bary-button>
        </div>
        <div class="col-auto">
          <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'modals.changeOrder.buttons.submit' | translate" color="primary"></jhi-bary-button>
        </div>
      </div>
    </div>
  </form>
</div>
